/** 总部直营租户 ID（平台超管） */
export const HQ_TENANT_ID = '0000';

/** 导航项：仅总部租户可见（tenantCode === HQ_TENANT_ID） */
export const NAV_ROLE_HQ_ONLY = 'hq-only';
